export const INIT_IS_GRANDFATHER = 'INIT_IS_GRANDFATHER';

export function initIsGrandfather(isGrandfather){
    return{
        type: INIT_IS_GRANDFATHER,
        mainState: {
            isGrandfather: isGrandfather
        }
    }
}